import { ArticleLayout } from '../-components/article-layout.tsx';

import heroImageSrc from './hero-image.webp';
import { articleMeta } from './meta.ts';

export default function Page() {
  return (
    <ArticleLayout
      meta={articleMeta}
      hero={
        <img
          src={heroImageSrc}
          alt={articleMeta.thumbAlt}
          fetchPriority="high"
          width={1770}
          height={995}
          className="w-full rounded-2xl"
        />
      }
    >
      <p>
        Forbruksgjelden i Norge har passert 181 milliarder kroner, og over 3,4 millioner nordmenn
        har kredittkort eller rammekreditt. I snitt sitter vi med rundt 22 000 kroner i utestående
        saldo, hvorav 12 000 kroner er rentebærende. Kjenner du deg igjen? Du er langt fra alene,
        her er 7 konkrete steg, uten at du trenger å eie bolig eller stille sikkerhet.
      </p>

      <h2>1. Få full oversikt</h2>
      <p>
        Skriv ned all gjeld: kredittkort, saldo, effektiv rente og minimumsbetaling. Kredittkort har
        typisk 20–30 % rente, blant de dyreste gjeldsformene som finnes. Uten oversikt vet du ikke
        hvor du bør sette inn støtet.
      </p>

      <h2>2. Velg strategi: snøball eller snøskred</h2>
      <p>
        <strong>Snøballmetoden:</strong> Betal ned minste gjeld først, gir raske seire og
        motivasjon.
        <br />
        <strong>Snøskredmetoden:</strong> Betal ned høyest rente først, mest lønnsomt.
        <br />
        <br />
        Velg det du faktisk klarer å holde deg til.
      </p>

      <h2>3. Sett opp et realistisk budsjett</h2>
      <p>
        Kartlegg inntekter og utgifter. Sjekk spesielt glemte abonnementer (strømming, trening,
        spill). Alt du frigjør kan gå til å betale ned mer enn minimumsbeløpet.
      </p>

      <h2>4. Bruk uforutsette utbetalinger smart</h2>
      <p>
        Feriepenger og skatteoppgjør er gode muligheter til å ta et større "hogg" i gjelden, det gir
        en garantert besparelse tilsvarende renten du slipper.
      </p>

      <h2>5. Vurder å samle gjelden i ett lån</h2>
      <p>
        Har du flere kredittkort med høy rente, kan et refinansieringslån uten sikkerhet gi lavere
        effektiv rente og én samlet betaling, uten at du trenger å eie bolig. Norske banker kan kun
        innvilge refinansiering hvis det faktisk blir billigere for deg.
      </p>

      <h2>6. Unngå å bygge ny gjeld i samme periode</h2>
      <p>
        Legg kredittkortet i en skuff (ikke kanseller det før eventuell refinansiering er på plass)
        og bruk debetkort i nedbetalingsperioden.
      </p>

      <h2>7. Ta kontakt hvis du står fast</h2>
      <p>
        Kontakt banken tidlig hvis minimumsbetalingene blir vanskelige, de fleste tilbyr
        nedbetalingsplaner. Gjeldsrådgivningstjenesten i kommunen og NAV gir også gratis, uavhengig
        veiledning.
      </p>

      <h2>Oppsummert</h2>
      <p>
        Det handler om oversikt, en plan du følger, og å redusere rentekostnaden. For mange er
        refinansiering uten sikkerhet det raskeste tiltaket, uten krav om bolig som sikkerhet.
      </p>
    </ArticleLayout>
  );
}
